import { IReservation } from "types/reservation"
import { useUI } from "providers/UIProvider"

import { getColumns } from "./columns"
import { getInsideActions } from "./insideActions"

import BdsLogo from "assets/img/bds-logo.png"
import { Text, Flex, Image } from "@chakra-ui/react"

import Table from "components/UI/organisms/Table"
import ReservationDetailsModal from "components/shared/modals/ReservationDetailsModal"
import CancelReservationModal from "components/shared/modals/CancelReservationModal"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { UI_INITIAL_STATE } from "providers/UIProvider/UIProviderConstants"
import WebReservationsModal from "components/shared/modals/WebReservationsModal"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"


const ReservationsTable = () => {
  const { modals, toggleModal, T, lang } = useUI()
  const { userRole, } = useAppContext();

  const { reservations,
    reservationsData,
    boxData,
    pageSize,
    handleTablePageSize,
    query,
    updateReservationBoxLoading,
    updateReservationWasherLoading,
    handleReservationsPageChange,
    handleBoxSelectChange,
    handleWasherSelectChange,
    handleViewReservationClick,
    handleCancelReservationClick,
    handleChangeReservationStatusClick,
    updateReservationStatus } = useReservationsContext()
  // const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER, IRoles.WASHER_ADMIN, IRoles.WASHER_MANAGER].includes(userRole);
  const startStopReservationClick = (reservationId: number, isStart: boolean) => {
    const startTitle = T("booking.start.title")
    const stopTitle = T("booking.stop.title")

    toggleModal("confirmationModal", true, {
      title: isStart ? startTitle : stopTitle,
      handleDeny: () => toggleModal("confirmationModal", false, UI_INITIAL_STATE.modals.confirmationModal.data),
      handleSubmit: () => updateReservationStatus(reservationId)
    })

    handleChangeReservationStatusClick(reservationId)
  }

  const viewReservationClick = (reservationId: number) => {
    toggleModal("reservationDetailsModal", true, null)
    handleViewReservationClick(reservationId)
  }

  const cancelReservationClick = (reservationId: number) => {
    toggleModal("cancelReservationModal", true)
    handleCancelReservationClick(reservationId)
  }

  const changeStatusClick = (reservationId: number) => {
    toggleModal("confirmationModal", true, {
      title: T("booking.status.reserved_to_in_place"),
      handleDeny: () => toggleModal("confirmationModal", false, UI_INITIAL_STATE.modals.confirmationModal.data),
      handleSubmit: () => updateReservationStatus(reservationId)
    })

    handleChangeReservationStatusClick(reservationId)
  }

  const columns = getColumns(T, {
    handleBoxSelectChange,
    handleWasherSelectChange,
    updateReservationBoxLoading,
    updateReservationWasherLoading,
    lang,
    reservedText: T("bookings.reserved"),
    isDisabled: userRole === IRoles.CASHIER,
    boxData: boxData,
    priceColor: userRole === IRoles.CASHIER ? "black" : "success",
    noBoxTranslated: T("bookings.no_box"),
    noWasherTranslated: T("bookings.washer.list_no_washer"),
    userRole: userRole
  })
  const insideActions = getInsideActions({
    handleStartClick: (data: IReservation) => startStopReservationClick(data.id, true),
    handleStopClick: (data: IReservation) => startStopReservationClick(data.id, false),
    handleViewClick: (data: IReservation) => viewReservationClick(data.id),
    handleCancelClick: (data: IReservation,) => cancelReservationClick(data.id),
    handleMoonClick: (data: IReservation) => changeStatusClick(data.id),
    userRole: userRole
  })


  return (
    <>
      <Table
        topBorderRadius={false}
        data={reservations.data}
        userRole={userRole}
        columns={columns}
        insideActions={insideActions}
        extraHeaderCols={1}
        pagination={{
          currentPage: query.pageIndex,
          perPage: query.pageSize,
          total: reservationsData?.data?.reservations.itemCount,
          onClick: handleReservationsPageChange,
        }}
        tableValue={pageSize?.value}
        handleTableSize={handleTablePageSize}
      />
      <Flex style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "5px", height: "2rem" }}>
        <Text style={{
          opacity: "50%",
          fontSize: "11px",
          whiteSpace: "nowrap",
        }}>
          {"Powered by"}
        </Text>
        <a target='_blank'
          rel='noopener noreferrer' href="https://bds.ge">
          <Image alt="BDS Logo" src={BdsLogo} height="14px" />
        </a>
      </Flex>
      {modals.reservationDetailsModal.isOpened && <ReservationDetailsModal />}
      {modals.cancelReservationModal.isOpened && <CancelReservationModal />}
      {(modals.webReservationsModal.isOpened || modals.webReservationsTimesModal) && <WebReservationsModal />}
    </>
  )
}

export default ReservationsTable
